import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Button,
  makeStyles,
  useMediaQuery,
  // Typography,
} from '@material-ui/core';
import PersonRoundedIcon from '@material-ui/icons/PersonRounded';

import Style from './Style';
import { AddIcon } from '../../constants';
import CustomerFields from './Components/CustomerFields';

const useStyles = makeStyles((theme) => Style(theme));

export default function AddCustomer({ toggle, setToggle }) {
  const classes = useStyles();
  const history = useHistory();

  const pathname = history.location?.pathname || '';

  useEffect(() => {
    if (pathname.includes('/dashboard')) {
      setToggle(false);
    }
  }, []);
  const matchesMedia = useMediaQuery('(max-width:1300px)');
  return (
    <>
      <div className='p-relative'>
        <Button
          className={classes.add__btn}
          onClick={() => {
            setToggle(!toggle);
          }}
          style={{ width: matchesMedia && '70px' }}
        >
          <AddIcon /> {matchesMedia ? <PersonRoundedIcon /> : 'New Customer'}
        </Button>

        {toggle && (
          <div className={classes.customer__fields}>
            <CustomerFields setToggle={setToggle} />
          </div>
        )}
      </div>
    </>
  );
}
